module.exports = __webpack_public_path__ + "img/the-viper-banner.6e20d580.png";